<template>
  <div class="root">
    <div class="grid-layout" :style="styleMap" data-grid>
      <component v-for="item in blok.content" :key="item._uid" :blok="item" :is="item.component" v-editable="item" :style="extractCSS(item, true)" class="component" data-grid-child>
      </component>
    </div>
  </div>
</template>

<script>
import cms from "@/mixins/cms.js";
export default {
  name: "cms-flow-grid",
  mixins: [cms],
  computed: {
    styleMap() {
      return {
        "--grid_md_cols": this.blok.md_cols || 2,
        "--grid_lg_cols": this.blok.lg_cols || 4,
      }
    }
  }
}
</script>

<style scoped>
div.grid-layout {
  --grid_cols: 1;
  display: grid;
  gap: var(--grid_gap);
  grid-template-columns: repeat(var(--grid_cols), 1fr);
}

@media screen and (min-width: 768px) {
  div.grid-layout {
    --grid_cols: var(--grid_md_cols);
  }
}

@media screen and (min-width: 1200px) {
  div.grid-layout {
    --grid_cols: var(--grid_lg_cols);
  }
}
</style>
